module.exports = __webpack_public_path__ + "static/media/visuel10.42f0f10c.jpg";